export default __webpack_public_path__ + "static/media/Screenshot 2022-11-02 at 18.53.50-1.a1c1a8a3.png";